'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var keyCodes = _interopDefault(require('../global/keycodes.js'));
var utils_js = require('../helpers/utils.js');

/**
 * Simple hover-triggered popover
 * @param {$DOM element} el Element hovering over which should trigger the popover.
 * @param {object} [options] optional configuration object
 * @param {string} [position] position of popover relative to trigger element. top/right/bottom/left. Defaults to bottom.
 * @class Popover
 * @namespace ShopifyMarketing
 * @constructor
*/
function Popover(el, options) {
  this.$el = utils_js.isJquery(el) ? el : $(el);

  this.config = _Object$assign({}, {
    position: this.$el.data('position') || 'bottom',
    toggleOnlyOnClick: this.$el.data('toggleOnlyOnClick') || false
  }, options);

  this.$popover = this.$el.find('.popover').first();
  this.$trigger = this.$el.find('.popover-trigger').first();
  this.$html = $('html, body');

  this.show = this.show.bind(this);
  this.hide = this.hide.bind(this);
  this._mouseEnter = this._mouseEnter.bind(this);
  this._mouseLeave = this._mouseLeave.bind(this);
  this._onClick = this._onClick.bind(this);
  this._onKeyUp = this._onKeyUp.bind(this);
  this._focus = this._focus.bind(this);
  this._focusOut = this._focusOut.bind(this);
  this._onBgClick = this._onBgClick.bind(this);

  if (!this.config.toggleOnlyOnClick) {
    this.$el.on('mouseenter', this._mouseEnter);
    this.$el.on('mouseleave', this._mouseLeave);
    this.$trigger.on('focus', this._focus);
  }

  this.$el.on('focusout', '*', utils_js.throttle(this._focusOut, 10));

  this.$trigger.on({
    click: this._onClick,
    keyup: this._onKeyUp
  });

  this.$popover.on('keyup', this._onKeyUp);

  this.isOpen = false;
  this.isOpening = false;

  this.init();
}

Popover.prototype.init = function () {
  var popoverId = utils_js.uniqueId('Popover');

  this.$popover.addClass('popover--' + this.config.position).attr('id', popoverId);

  this.$trigger.attr({
    'aria-expanded': 'false',
    'aria-describedby': popoverId,
    'aria-haspopup': true
  });
};

/**
 * Show popover
 * @method show
*/
Popover.prototype.show = function () {
  var _this = this;

  this.$html.on('click.popover', this._onBgClick);

  this.$popover.outerWidth();
  this.$el.addClass('js-is-active');
  this.$trigger.attr('aria-expanded', 'true');

  this.isOpen = true;
  this.isOpening = true;
  if (this.config.onShow) {
    this.config.onShow.call(this);
  }

  // This prevents anxious trigger clicking from closing the popover at an
  // unwanted time. 600ms 'felt' best, but is entirely magic.
  setTimeout(function () {
    _this.isOpening = false;
  }, 600);
};

/**
 * Hide popover
 * @method hide
*/
Popover.prototype.hide = function () {
  this.$html.off('.popover');

  this.$trigger.attr('aria-expanded', 'false');
  this.$el.removeClass('js-is-active');
  this.isOpen = false;
  if (this.config.onHide) {
    this.config.onHide.call(this);
  }
};

Popover.prototype._focus = function () {
  setTimeout(this.show, 10);
};

Popover.prototype._focusOut = function () {
  var _this2 = this;

  setTimeout(function () {
    if (_this2.$el.find(':focus').length) {
      return;
    }
    _this2.hide();
  }, 10);
};

Popover.prototype._mouseEnter = function () {
  this.show();
};

Popover.prototype._mouseLeave = function () {
  this.hide();
};

Popover.prototype._onBgClick = function (evt) {
  var $target = $(evt.target);

  // 1) Popover shouldn't be isOpening
  // 2) Target shouldn't be the popover itself
  // 3) Target's parents shouldn't include the popover
  if (!this.isOpening && evt.target !== this.$popover && !$target.parents().is(this.$popover)) {
    this.hide();
  }
};

Popover.prototype.toggle = function () {
  if (this.isOpen) {
    this.hide();
  } else {
    this.show();
  }
};

Popover.prototype._onClick = function () {
  if (!this.isOpening || this.config.toggleOnlyOnClick) {
    this.toggle();
  }
};

Popover.prototype._onKeyUp = function (evt) {
  switch (evt.keyCode) {
    case keyCodes.SPACE:
      evt.preventDefault();
      evt.stopPropagation();
      this.toggle();
      break;
    case keyCodes.ESCAPE:
      this.hide();
      this.$trigger.focus();
  }
};

module.exports = Popover;
